import { setMaxPrice, setMinPrice, setPriceStep } from "../store/slices/botSlice";
import { AppDispatch } from "../store/store";
import { Bot, CustomGridOrder, GridType, GridTypeEnum, RangeStart } from "../_app/types";
import { _roundDec, _roundToDecimals } from "./_roundToDecimals";
import { precision } from "./_precision";
import { useMemo } from "react";
import formatNumber from "./formatNumber";

// TODO добавить в эти функции округление по ticker priceStep
export function calcOrderFieldsGridAmount(
  gridsAmount: number,
  dispatch: AppDispatch,
  bot: Bot,
  rangeStartMode: RangeStart
) {
  let precisionPS = Math.abs(Math.log10(bot.ticker.priceStep));
  let priceStepAfterCalcRound = bot.priceStep; // default current priceStep
  let psHalfUp = 0;
  let psHalfDown = 0;
  let rangeDivision = 0;

  if (rangeStartMode === "range") {
    if (bot.gridType === "ARITHMETIC") {
      priceStepAfterCalcRound = Math.abs(bot.customHighPrice - bot.customLowPrice) / bot.gridsAmount;
      priceStepAfterCalcRound = _roundDec(priceStepAfterCalcRound, precision(bot.ticker.priceStep));
    } else {
      // geometric
      if (rangeStartMode === "range") {
        rangeDivision = Math.abs(bot.customHighPrice / bot.customLowPrice);
      } else {
        rangeDivision = Math.abs(bot.maxPrice / bot.minPrice);
      }
      let pow = 2 / gridsAmount;

      if (rangeDivision !== 0) {
        priceStepAfterCalcRound =
          (Math.pow(rangeDivision, pow) - 1) / (1 + Math.pow(rangeDivision, pow));
        psHalfUp = _roundDec(priceStepAfterCalcRound, 4, true);
        psHalfDown = _roundDec(priceStepAfterCalcRound, 4, false);
        priceStepAfterCalcRound = _roundDec(priceStepAfterCalcRound, 4);
      }
    }
  }

  if (bot.gridType === "ARITHMETIC") {
    switch (bot.gridDirection) {
      case "Central":
        dispatch(
          setMaxPrice(
            _roundDec(bot.startPrice + (bot.gridsAmount / 2) * priceStepAfterCalcRound, precisionPS)
          )
        );
        dispatch(
          setMinPrice(
            _roundDec(bot.startPrice - (bot.gridsAmount / 2) * priceStepAfterCalcRound, precisionPS)
          )
        );
        dispatch(setPriceStep(priceStepAfterCalcRound));
        break;
      case "Long":
        dispatch(setMaxPrice(_roundDec(bot.startPrice, precisionPS)));
        dispatch(
          setMinPrice(
            _roundDec(bot.startPrice - bot.gridsAmount * priceStepAfterCalcRound, precisionPS)
          )
        );
        dispatch(setPriceStep(priceStepAfterCalcRound));
        break;
      case "Short":
        dispatch(
          setMaxPrice(
            _roundDec(bot.startPrice + bot.gridsAmount * priceStepAfterCalcRound, precisionPS)
          )
        );
        dispatch(setMinPrice(_roundDec(bot.startPrice, precisionPS)));
        dispatch(setPriceStep(priceStepAfterCalcRound));
        break;
      default:
        break;
    }
  } else {
    // geometric
    switch (bot.gridDirection) {
      case "Central":
        // TODO Add check range rule for "Central" variant
        if (rangeStartMode === "range") {
          let minPriceUp = _roundDec(
            bot.startPrice / Math.pow(1 + psHalfUp, gridsAmount / 2),
            precisionPS
          );
          let minPriceDown = _roundDec(
            bot.startPrice / Math.pow(1 + psHalfDown, gridsAmount / 2),
            precisionPS
          );
          let maxPriceUp = _roundDec(
            bot.startPrice / Math.pow(1 - psHalfUp, gridsAmount / 2),
            precisionPS
          );
          let maxPriceDown = _roundDec(
            bot.startPrice / Math.pow(1 - psHalfDown, gridsAmount / 2),
            precisionPS
          );

          if (
            Math.abs(minPriceUp - bot.customLowPrice) < Math.abs(minPriceDown - bot.customLowPrice)
          ) {
            dispatch(setMinPrice(minPriceUp));
            dispatch(setPriceStep(psHalfUp));
          } else {
            dispatch(setMinPrice(minPriceDown));
            dispatch(setMaxPrice(maxPriceDown));
          }

          if (
            Math.abs(maxPriceUp - bot.customHighPrice) <
            Math.abs(maxPriceDown - bot.customHighPrice)
          ) {
            dispatch(setMaxPrice(maxPriceUp));
            dispatch(setPriceStep(psHalfUp));
          } else {
            dispatch(setMaxPrice(maxPriceDown));
            dispatch(setPriceStep(psHalfDown));
          }
        } else {
          dispatch(
            setMinPrice(
              _roundDec(
                bot.startPrice / Math.pow(1 + priceStepAfterCalcRound, gridsAmount / 2),
                precisionPS
              )
            )
          );
          dispatch(
            setMaxPrice(
              _roundDec(
                bot.startPrice / Math.pow(1 - priceStepAfterCalcRound, gridsAmount / 2),
                precisionPS
              )
            )
          );
          dispatch(setPriceStep(priceStepAfterCalcRound));
        }
        break;
      case "Long":
        if (rangeStartMode === "range") {
          let minPriceUp = _roundDec(
            bot.startPrice / Math.pow(1 + psHalfUp, gridsAmount),
            precisionPS
          );
          let minPriceDown = _roundDec(
            bot.startPrice / Math.pow(1 + psHalfDown, gridsAmount),
            precisionPS
          );
          if (
            Math.abs(minPriceUp - bot.customLowPrice) < Math.abs(minPriceDown - bot.customLowPrice)
          ) {
            dispatch(setMinPrice(minPriceUp));
            dispatch(setMaxPrice(_roundDec(bot.startPrice, precisionPS)));
            dispatch(setPriceStep(psHalfUp));
          } else {
            dispatch(setMinPrice(minPriceDown));
            dispatch(setMaxPrice(_roundDec(bot.startPrice, precisionPS)));
            dispatch(setPriceStep(psHalfDown));
          }
        } else {
          dispatch(
            setMinPrice(
              _roundDec(
                bot.startPrice / Math.pow(1 + priceStepAfterCalcRound, gridsAmount),
                precisionPS
              )
            )
          );
          dispatch(setMaxPrice(_roundDec(bot.startPrice, precisionPS)));
        }
        break;
      case "Short":
        let maxPriceUp = _roundDec(
          bot.startPrice / Math.pow(1 - psHalfUp, gridsAmount),
          precisionPS
        );
        let maxPriceDown = _roundDec(
          bot.startPrice / Math.pow(1 - psHalfDown, gridsAmount),
          precisionPS
        );
        if (rangeStartMode === "range") {
          if (
            Math.abs(maxPriceUp - bot.customHighPrice) <
            Math.abs(maxPriceDown - bot.customHighPrice)
          ) {
            console.log("psHalfUp", psHalfUp);
            console.log("maxPriceUp", maxPriceUp);
            dispatch(setMaxPrice(maxPriceUp));
            dispatch(setPriceStep(psHalfUp));
          } else {
            console.log("psHalfDown", psHalfDown);
            console.log("maxPriceDown", maxPriceDown);
            dispatch(setMaxPrice(maxPriceDown));
            dispatch(setPriceStep(psHalfDown));
          }
          dispatch(setMinPrice(_roundDec(bot.startPrice, precisionPS)));
          dispatch(setPriceStep(priceStepAfterCalcRound));
        } else {
          dispatch(setMinPrice(_roundDec(bot.startPrice, precisionPS)));
          dispatch(
            setMaxPrice(
              _roundDec(
                bot.startPrice / Math.pow(1 - priceStepAfterCalcRound, gridsAmount),
                precisionPS
              )
            )
          );
        }
        break;
      default:
        break;
    }
  }
  // rounded calc priceStep after changed gridsAmount
}

// TODO добавить в эти функции округление по ticker priceStep
export function calcOrderFieldsPriceStep(
  priceStepUser: number,
  dispatch: AppDispatch,
  bot: Bot,
  rangeStartMode: RangeStart
) {
  let priceStepPrecision = Math.abs(Math.log10(bot.ticker.priceStep));
  let priceStepAfterCalcRound = priceStepUser; // default current priceStep
  console.log("priceStepUser", priceStepUser);

  if (rangeStartMode === "range") {
    if (bot.gridType === "ARITHMETIC") {
      priceStepAfterCalcRound = Math.abs(bot.maxPrice - bot.minPrice) / bot.gridsAmount;
      priceStepAfterCalcRound = _roundDec(priceStepAfterCalcRound, precision(bot.ticker.priceStep));
    } else {
      let rangeDivision = Math.abs(bot.maxPrice / bot.minPrice);
      let pow = 2 / bot.gridsAmount;
      priceStepAfterCalcRound =
        (Math.pow(rangeDivision, pow) - 1) / (1 + Math.pow(rangeDivision, pow));
      // priceStepAfterCalcRound = _roundDec(priceStepAfterCalcRound, 2);
    }
  }

  if (bot.gridType === "ARITHMETIC") {
    switch (bot.gridDirection) {
      case "Central":
        dispatch(
          setMaxPrice(
            _roundDec(
              bot.startPrice + (bot.gridsAmount / 2) * priceStepAfterCalcRound,
              priceStepPrecision
            )
          )
        );
        dispatch(
          setMinPrice(
            _roundDec(
              bot.startPrice - (bot.gridsAmount / 2) * priceStepAfterCalcRound,
              priceStepPrecision
            )
          )
        );
        break;
      case "Long":
        dispatch(setMaxPrice(_roundDec(bot.startPrice, priceStepPrecision)));
        dispatch(
          setMinPrice(
            _roundDec(
              bot.startPrice - bot.gridsAmount * priceStepAfterCalcRound,
              priceStepPrecision
            )
          )
        );
        break;
      case "Short":
        dispatch(
          setMaxPrice(
            _roundDec(
              bot.startPrice + bot.gridsAmount * priceStepAfterCalcRound,
              priceStepPrecision
            )
          )
        );
        dispatch(setMinPrice(_roundDec(bot.startPrice, priceStepPrecision)));
        break;
      default:
        break;
    }
  } else if (bot.gridType === "GEOMETRIC") {
    switch (bot.gridDirection) {
      case "Central":
        dispatch(
          setMinPrice(
            _roundDec(
              bot.startPrice / Math.pow(1 + priceStepAfterCalcRound, bot.gridsAmount / 2),
              priceStepPrecision
            )
          )
        );
        dispatch(
          setMaxPrice(
            _roundDec(
              bot.startPrice / Math.pow(1 - priceStepAfterCalcRound, bot.gridsAmount / 2),
              priceStepPrecision
            )
          )
        );
        break;
      case "Long":
        dispatch(
          setMinPrice(
            _roundDec(
              bot.startPrice / Math.pow(1 + priceStepAfterCalcRound, bot.gridsAmount),
              priceStepPrecision
            )
          )
        );
        dispatch(setMaxPrice(_roundDec(bot.startPrice, priceStepPrecision)));
        break;
      case "Short":
        dispatch(setMinPrice(_roundDec(bot.startPrice, priceStepPrecision)));
        dispatch(
          setMaxPrice(
            _roundDec(
              bot.startPrice / Math.pow(1 - priceStepAfterCalcRound, bot.gridsAmount),
              priceStepPrecision
            )
          )
        );
        break;
      default:
        break;
    }
  }
}

export function calcPriceStep(
  gridType: GridType,
  min: number,
  max: number,
  gridsAmount: number,
  tickerPriceStep: number
): number {
  if (gridType === GridTypeEnum.Arithmetic) {
    // вычислил ps, округлил ps
    // потом вычислил min max и округлил
    return _roundDec(Math.abs(max - min) / gridsAmount, Math.abs(Math.log10(tickerPriceStep)));
  } else {
    let rangeDivision = Math.abs(max / min);
    let pow = 2 / gridsAmount;
    return (Math.pow(rangeDivision, pow) - 1) / (1 + Math.pow(rangeDivision, pow));
    // return _roundDec((Math.pow(rangeDivision, pow) - 1)
    // 	/ (1 + Math.pow(rangeDivision, pow)), Math.abs(Math.log10(tickerPriceStep)))
  }
}

export function printPriceStepRange(customOrders: CustomGridOrder[]): string {
  const minPs = Math.min(
    ...customOrders.flatMap((order) =>
      _roundDec(
        (Math.abs(
          order.orderSide === "Long"
            ? order.closePrice - order.openPrice
            : order.openPrice - order.closePrice
        ) /
          order.openPrice) *
          100,
        2
      )
    )
  );
  const maxPs = Math.max(
    ...customOrders.flatMap((order) =>
      _roundDec(
        (Math.abs(
          order.orderSide === "Long"
            ? order.closePrice - order.openPrice
            : order.openPrice - order.closePrice
        ) /
          order.openPrice) *
          100,
        2
      )
    )
  );

  return `${minPs}% \u2014 ${maxPs}%`;
}

export function printProfitPerOrderRange(customOrders: CustomGridOrder[]): string {
  const minProfit = Math.min(
    ...customOrders.flatMap((order) =>
      _roundDec(
        (order.orderSide === "Long"
          ? order.closePrice - order.openPrice
          : order.openPrice - order.closePrice) * order.amount,
        2
      )
    )
  );
  const maxProfit = Math.max(
    ...customOrders.flatMap((order) =>
      _roundDec(
        Math.abs(
          order.orderSide === "Long"
            ? order.closePrice - order.openPrice
            : order.openPrice - order.closePrice
        ) * order.amount,
        2
      )
    )
  );

  return `$${formatNumber(minProfit)} - $${formatNumber(maxProfit)}`;
}

export function getAverageProfitOrders(customOrders: CustomGridOrder[]): number {
  const profits = customOrders.flatMap((order) => {
    const profit = _roundDec(
      (order.orderSide === "Long"
        ? order.closePrice - order.openPrice
        : order.openPrice - order.closePrice) * order.amount,
      2
    );
    return profit;
  });

  const minProfit = Math.min(...profits);
  const maxProfit = Math.max(...profits);

  const totalProfit = profits.reduce((sum, profit) => sum + profit, 0);

  return profits.length > 0 ? totalProfit / profits.length : 0;
}

// export function getAverageProfitOrders(orders: CustomGridOrder[], gridType: GridType): number {
// 	const result = orders.reduce<{ sum: number; count: number }>(
// 		(acc, item) => {
// 			const value = gridType === 'ARITHMETIC' ? item.priceStepPercent * 100 : item.priceStep;
// 			acc.sum += value;
// 			acc.count += 1;
// 			return acc;
// 		},
// 		{ sum: 0, count: 0 }
// 	);
//
// 	const average = result.count > 0 ? result.sum / result.count : 0;
// }
